module.exports = __webpack_public_path__ + "img/hr-water-inner-corner.3800bd76.png";